import { siteModel } from 'models/SiteModel';

export class loadCoverAsync {
    load(day) {
        const executeLoadingData = (resolve, reject) => {
        $.get(`${siteModel.get('paths').coverRepository.replace('2000-08-20', day)}`)
            .done((response) => {
                const { status, data, redirectURL } = response;

                if (status === 'ok') {
                    resolve(data);
                } else if (status === 'error') {
                    reject(data.error);
                } else if (status === 'redirect') {
                    window.location.href = redirectURL;
                }
            })
            .fail((error) => {
                reject(error);
            });
        };
        return new Promise(executeLoadingData);
    }
};

export const repository = new loadCoverAsync();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/repositories/coverRepository.js